import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { SuppliersService } from '../suppliers.service'; 
import { Supplier } from '../suppliers.model';

@Component({
  selector: 'app-supplier-form',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    ToastModule
  ],
  templateUrl: './form-suppliers.component.html',
  providers: [MessageService]
})
export class FormSuppliersComponent implements OnInit {
  supplierId: number | null = null;
  supplierForm!: FormGroup;
  isEditMode = false;
  pageTitle = 'Create New Supplier';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,      
    private SuppliersService: SuppliersService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.supplierId = +id;
        this.isEditMode = true;
        this.pageTitle = 'Edit Supplier';
        this.loadSupplierData(this.supplierId); 
      }
    });
  }

  initForm(): void {
    this.supplierForm = this.fb.group({
      supplierName: ['', Validators.required],
      supplierNumber: [''],
    });
  }

  loadSupplierData(id: number): void {
    this.SuppliersService.getSupplierById(id).subscribe({
      next: (supplier) => this.supplierForm.patchValue(supplier),
      error: (err) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load business unit data.' });
        console.error(err);
      }
    });
  }

  saveSupplier(): void {
    if (this.supplierForm.invalid) {
      this.supplierForm.markAllAsTouched(); 
      return;
    }

    const supplierData: Supplier = { id: this.supplierId ?? 0, ...this.supplierForm.value };
    console.log(this.supplierForm.value);
    const operation = this.isEditMode
      ? this.SuppliersService.updateSupplier(supplierData)
      : this.SuppliersService.createSupplier(supplierData);

    operation.subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: `Supplier ${this.isEditMode ? 'updated' : 'created'} successfully.` });
        setTimeout(() => this.router.navigate(['/ai-studio/session/current', { outlets: { canvasOutlet: ['supplier', 'list'] } }]), 1500);
      },
      error: (err) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: `Failed to ${this.isEditMode ? 'update' : 'create'} branch.` });
        console.error(err);
      }
    });
  }

  cancel(): void {
    this.router.navigate(['/ai-studio/session/current', { outlets: { canvasOutlet: ['supplier', 'list'] } }]);
  }
}
